module.exports = __webpack_public_path__ + "img/tea.8b0e4250.svg";